import { render, staticRenderFns } from "./OrderDetailsSheet.vue?vue&type=template&id=84c3cae6&scoped=true"
import script from "./OrderDetailsSheet.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderDetailsSheet.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrderDetailsSheet.vue?vue&type=style&index=0&id=84c3cae6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c3cae6",
  null
  
)

export default component.exports